import z from 'zod';

import { api } from 'common';
import { Flow } from 'vivaa-api';

export enum HumanTaskAppVariant {
  StaffApp = 'StaffApp',
  CopilotApp = 'CopilotApp',
}

export type HumanTask = api.Flow.HumanTask.HumanTask;

export const HumanTaskState = Flow.HumanTask.HumanTaskState;
export type HumanTaskState = Flow.HumanTask.HumanTaskState;

export import HumanTaskTool = api.FlowDefinition.HumanTaskTool;

export const HumanTaskQueryParamsSchema = z.object({
  agentId: z.string().optional(),
  flowId: z.string().optional(),
  organizationId: z.string().optional(),
  categoryId: z.array(z.string()).optional(),
  states: z.array(z.enum(api.Flow.HumanTask.HumanTaskState)).optional(),
  searchTerm: z.string().optional(),
  assignedToId: z.string().uuid().optional(),
  q: z.string().optional(),
  tags: z.array(z.string()).optional(),
  createdRange: z
    .object({
      after: z.iso.datetime().optional(),
      before: z.iso.datetime().optional(),
    })
    .optional(),
  expiresRange: z
    .object({
      after: z.iso.datetime().optional(),
      before: z.iso.datetime().optional(),
    })
    .optional(),
  sortModel: z.array(
    z.object({
      field: z.string(),
      sort: z.enum(api.Common.SortOrder),
    })
  ),
});
export type HumanTaskQueryParams = z.infer<typeof HumanTaskQueryParamsSchema>;
